import { useBuildSearchParams } from "routes/hooks";
import * as URI from "uri-js";

function useSendEmailToService() {
  const prefix = (p, s) => {
    return s ? p + s : "";
  };
  const buildQueryParams = useBuildSearchParams();

  return (to, subject, body, service) => {
    switch (service) {
      case "gmail":
        return URI.serialize({
          scheme: "https",
          host: "mail.google.com",
          path: "/mail/u/0",
          query: `view=cm&fs=1&tf=1&source=mailto${prefix(
            "&",
            buildQueryParams([
              ["su", subject],
              ["to", to],
              ["body", body],
            ]).toString()
          )}`,
        });
      case "outlook":
        return URI.serialize({
          scheme: "https",
          host: "outlook.live.com",
          path: "/owa",
          query: `path=/mail/action/compose${prefix(
            "&",
            buildQueryParams([
              ["subject", subject],
              ["to", to],
              ["body", body],
            ]).toString()
          )}`,
        });
      case "yahoo":
        return URI.serialize({
          scheme: "https",
          host: "compose.mail.yahoo.com",
          path: "/mail/u/0",
          query: prefix(
            "&",
            buildQueryParams([
              ["subj", subject],
              ["to", to],
              ["body", body],
            ]).toString()
          ),
        });
      case "local":
        return URI.serialize({
          scheme: "mailto",
          to: to,
          subject: subject,
          body: body,
        });
      default:
        return "";
    }
  };
}
export default useSendEmailToService;
